/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum PrecalcAvailability {
  None = 0,
  Month = 1,
  YearStart = 2,
  YearEnd = 3,
}
